<template>
  <div class="launching-des">
    <a :href="`${baseUrl}/#e-visits`">{{ $t("announcement.message") }}</a>
  </div>
</template>

<script setup>
const config = useRuntimeConfig();
const baseUrl = config.public.baseUrl;
</script>

<style lang="scss" scoped>
.launching-des {
  width: 100%;
  margin-top: 0px;
  padding: 0.25rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-inline: auto;
  background: rgba(255, 76, 226, 1);
  a {
    font-family: "DM Sans", sans-serif;
    text-wrap: wrap;
    text-align: center;
    text-decoration: none;
    font-weight: 500;
    tab-size: 4;
    line-height: 24px;
    font-size: 0.9rem;
    text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.6);
    color: white;
    &:hover {
      text-decoration: underline;
    }
    @include respond-below(sm) {
      font-size: 0.8rem;
    }
  }
}
</style>
